import * as React from 'react'
import {Feature} from '../../../core/models'
import AppReadOnlyView from '../AppReadOnlyView'
import {IFeatureLayerInfo} from '../../../core/interfaces/models'
export class StreetAreaView extends AppReadOnlyView {
  protected getValue(fieldName: string, value: string, feature: Feature, layerInfo: IFeatureLayerInfo) {
    if (fieldName == 'Points' && !!value) {
      const points = value.split('↕')
      let i = 0
      let j = 0
      const temparray: string[][] = []
      const chunk = 10
      for (i = 0, j = points.length; i < j; i += chunk) {
        temparray.push(points.slice(i, i + chunk))
      }
      return (
        <table>
          <tbody>
            {temparray.map((k, j) => (
              <tr key={j}>
                {k.map((p, i) => (
                  <td key={i} style={{margin: '2px'}}>
                    {p.split('▐')[1]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )
    }
    return <div className="detail-view-value">{value}</div>
  }
}
